import type { IconProps } from './IconProps';

export const RefreshIcon = (props: IconProps) => (
  <svg
    viewBox="-1.25 -1.25 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M0 6.75C0 3.02208 3.02208 0 6.75 0C8.6145 0 10.3036 0.756968 11.5244 1.97852C11.9022 2.35653 12.302 2.81345 12.667 3.25098V1.41699C12.667 1.00278 13.0028 0.666992 13.417 0.666992C13.8311 0.667168 14.167 1.00289 14.167 1.41699V5.41699C14.1668 5.83095 13.8309 6.16682 13.417 6.16699H9.41699C9.00289 6.16699 8.66717 5.83106 8.66699 5.41699C8.66699 5.00278 9.00278 4.66699 9.41699 4.66699H11.8887C11.4486 4.11993 10.927 3.5025 10.4639 3.03906C9.51288 2.08742 8.20061 1.5 6.75 1.5C3.85051 1.5 1.5 3.85051 1.5 6.75C1.5 9.6495 3.85051 12 6.75 12C9.1423 12 11.1628 10.3993 11.7949 8.20898C11.9098 7.81101 12.3257 7.58145 12.7236 7.69629C13.1215 7.81123 13.3511 8.22711 13.2363 8.625C12.4239 11.4401 9.8283 13.5 6.75 13.5C3.02208 13.5 0 10.4779 0 6.75Z"
      fill="currentColor"
    />
  </svg>
);
